import React, { useState } from "react";

export default function StatsOverviewPageUk() {
  const [lightbox, setLightbox] = useState({ open: false, src: "", alt: "" });

  const Thumbnail = ({ src, alt }) => (
    <div style={{ marginTop: 8 }}>
      <img
        src={src}
        alt={alt}
        onClick={() => setLightbox({ open: true, src, alt })}
        style={{
          width: "15cm",
          height: "auto",
          display: "block",
          cursor: "zoom-in",
          borderRadius: 8,
        }}
      />
    </div>
  );

  return (
    <>
      <div
        style={{
          maxWidth: 900,
          margin: "48px auto",
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 2px 12px #0001",
          padding: 36,
          fontFamily: "inherit",
          color: "#222",
        }}
      >
        <h2 id="stats-hero" style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
          Аналітичні сервіси для онлайн-радіо
        </h2>

        <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
          <strong>Radiomonitor.net</strong> - це не просто збір даних, а їх глибокий аналіз. Ви бачите,
          як змінюється аудиторія в реальному часі, відстежуєте динаміку за день, тиждень
          місяць, навість, за рік! Аналізуєте прайм-тайми та ефективність контенту
        </p>
        <p style={{ margin: "0 0 24px", fontSize: 18 }}>
          Далі — детальніше про сервіси, які роблять це можливим:
        </p>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Активні слухачі</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Що відбувається зараз?</b><br />
            Показує кількість слухачів у реальному часі: прямо зараз, з яких пристроїв і з яких міст. Онлайн-аналітика “тут і зараз”.
          </p>
          <Thumbnail
            src="/assets/stats/LiveService(uk).png"
            alt="Активні слухачі — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Слухачі</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Хто слухає вас?</b><br />
            Рахує всі підключення та унікальних слухачів. Базова метрика аудиторії, без якої не працює жоден інший аналіз.
          </p>
          <Thumbnail
            src="/assets/stats/ListenersService(uk).png"
            alt="Слухачі — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Пристрої та ОС (Devices & OS)
            <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
              Devices & OS / Audience Devices & Operating Systems
            </span>
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Цей сервіс показує, з яких пристроїв і операційних систем слухають вашу радіостанцію у вибрану дату (за сесіями).
            Система агрегує сесії прослуховування та формує зрозумілий профіль технічної аудиторії — щоб ви бачили, де саме «живе» ваш слухач і під що оптимізувати плеєр, сайт, застосунок та рекламні матеріали.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>У звіті можна побачити:</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Тип пристрою (наприклад: Mobile / Desktop / Other)</li>
            <li>Операційну систему (Android, iOS, Windows, macOS тощо)</li>
            <li>Сімейство пристроїв (device family, топ категорій)</li>
            <li>Клієнти (top client — типи клієнтських застосунків/плеєрів)</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Навіщо це потрібно:</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Оптимізація продукту: зрозуміти, що домінує (Android vs iOS, мобайл vs десктоп) і під це пріоритезувати UI/UX, тестування та підтримку.</li>
            <li>Якість стріму та плеєра: швидко виявляти аномалії по конкретних ОС/клієнтах (якщо певний плеєр дає багато обривів або «дивні» сесії).</li>
            <li>Планування розвитку: аргументовано вирішувати, чи потрібен окремий застосунок/оновлення і які платформи підтримувати першими.</li>
            <li>Реклама й партнерства: підбирати формати та креативи під технічний профіль аудиторії й підтверджувати його рекламодавцям.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Період аналізу:</b> вибрана дата (за потреби є фільтр за країною).
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Методика розрахунку:</b> агрегація сесій прослуховування у вибраній даті → групування за типом пристрою / ОС / сімейством / клієнтом → підрахунок кількості та частки (%) у загальному обсязі сесій.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
            <Thumbnail src="/assets/stats/Devices&OS01_uk.png" alt="Devices & OS — розподіл за типом пристрою" />
            <Thumbnail src="/assets/stats/Devices&OS02_uk.png" alt="Devices & OS — звіт та графік" />
          </div>
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Географія слухачів</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Де слухають?</b><br />
            Визначає географію слухачів — країни, міста, частку української аудиторії. Дає чітку картину охоплення по регіонах.
          </p>
          <Thumbnail
            src="/assets/stats/Geo(uk).png"
            alt="Географія слухачів — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Пікові навантаження</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Коли вас слухають найбільше?</b><br />
            Визначає пікові години і прайм-тайм вашого ефіру. Ідеально для планування рекламних вставок.
          </p>
          <Thumbnail
            src="/assets/stats/PeakService(uk).png"
            alt="Пікові навантаження — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Середньогодинний профіль слухання за днями тижня (AHA)
            <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
              Day-of-Week Listening Profile / Average Hourly Audience by Day of Week
            </span>
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Цей показник демонструє, як змінюється середня аудиторія радіостанції протягом доби залежно від дня тижня.
            Для кожного дня (понеділок, вівторок, … неділя) система обчислює середнє значення слухачів по годинах,
            усереднюючи всі однойменні дні у вибраному періоді — наприклад, усі понеділки місяця або всі неділі за останні три місяці.
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>побачити характерні відмінності між буднями та вихідними;</li>
            <li>визначити години найбільшої активності слухачів у кожен день;</li>
            <li>перевірити сталість аудиторії в межах тижня;</li>
            <li>підтвердити або скоригувати прайм-тайми.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.5 }}>
            Періоди аналізу: 1, 3, 6, 9 або 12 місяців.<br />
            Методика розрахунку: середнє по хвилинах → середнє по годинах → середнє по однакових слотах (день тижня, година).
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
            <Thumbnail
              src="/assets/stats/AHA (ukr)1.png"
              alt="Середньогодинний профіль — графік"
            />
            <Thumbnail
              src="/assets/stats/AHA (ukr)2.png"
              alt="Середньогодинний профіль — теплокарта"
            />
          </div>
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TSL</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Як довго слухають?</b><br />
            Обчислює середній час прослуховування (TSL). Показує рівень залучення аудиторії та якість контенту.
          </p>
          <Thumbnail
            src="/assets/stats/TslService(uk).png"
            alt="TSL — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TLH</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            TLH (Total Listening Hours) — це метрика, яка показує, скільки годин сумарно слухали вашу радіостанцію за обраний період.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Що рахує TLH</b><br />
            TLH підсумовує тривалість усіх сесій прослуховування та переводить її в години:
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>TLH за день — скільки "людино-годин" прослуховування було в конкретний день.</li>
            <li>TLH за період (підсумок) — загальна кількість годин прослуховування за інтервал (день/тиждень/місяць).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Простими словами: TLH відповідає на запитання «скільки часу аудиторія провела з нашою станцією?».
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Навіщо це потрібно</b><br />
            TLH — одна з найбільш зрозумілих "валют" для оцінки аудиторії та монетизації:
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Для продажу реклами: TLH легко пояснити рекламодавцю як обсяг контакту з контентом — "стільки людино-годин прослуховування".</li>
            <li>Для порівняння періодів: видно, чи зростає загальний обсяг прослуховування тиждень до тижня або місяць до місяця.</li>
            <li>Для оцінки ефективності змін і промо: після рекламної кампанії, зміни формату або ведучих TLH показує, чи збільшився сумарний "час уваги" до станції.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Як інтерпретувати результат</b>
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Графік по днях — скільки годин сумарного прослуховування було в кожен день періоду.</li>
            <li>TLH (підсумок) — суму годин за весь період.</li>
            <li>Кількість сесій — скільки підключень було за період (допомагає зрозуміти, за рахунок чого змінився TLH).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            TLH зручно використовувати разом з іншими метриками (наприклад, TSL), але сам по собі він дає просте та "комерційно зрозуміле" число: скільки годин уваги отримала станція.
          </p>
          <Thumbnail
            src="/assets/stats/tlh_uk.png"
            alt="TLH — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Нові слухачі</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Скільки нових прийшло?</b><br />
            Визначає кількість нових слухачів за день, тиждень чи місяць. Дає зрозуміти, як росте ваша аудиторія.
          </p>
          <Thumbnail
            src="/assets/stats/NewListenersService(uk).png"
            alt="Нові слухачі — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            ADR (Average Daily Reach)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Середньодобове охоплення радіостанції (ADR).</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Цей показник показує, скільки <b>унікальних слухачів</b> у середньому щодня приходять на вашу станцію в обраний період.
            Для кожного дня в діапазоні система рахує, скільки різних людей слухали радіо, а потім усереднює ці значення за весь період.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>ADR дозволяє:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>оцінити <b>реальний розмір щоденної аудиторії</b> станції;</li>
            <li>зрозуміти, наскільки стабільно радіо залучає слухачів у вибраний період;</li>
            <li>підкріплювати комерційні пропозиції <b>зрозумілою цифрою охоплення</b> за період.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Період аналізу:</b> обраний діапазон дат у межах доступної історії прослуховувань.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Методика розрахунку:</b></p>
          <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Для кожного дня в періоді визначається <b>кількість унікальних слухачів за добу</b>.</li>
            <li>Отримані значення по днях <b>усереднюються</b>, формуючи показник Average Daily Reach для всього обраного періоду.</li>
          </ol>
          <Thumbnail
            src="/assets/stats/ADR (uk).png"
            alt="ADR — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            AQH (Average Quarter-Hour Audience)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Середня кількість одночасних слухачів.</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Показує, <b>скільки слухачів у середньому одночасно</b> слухають станцію у вибраному періоді.
            Система агрегує всі сесії за часовими інтервалами (наприклад, по годинах) і відображає середній розмір аудиторії для кожного інтервалу.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>AQH дозволяє:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>бачити, як змінюється аудиторія протягом доби;</li>
            <li>визначати години з максимальним і мінімальним попитом;</li>
            <li>планувати рекламу у вигідні часові слоти;</li>
            <li>оцінювати вплив змін у програмній сітці.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Період аналізу:</b> будь-який доступний діапазон дат.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Методика розрахунку:</b></p>
          <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>Для кожної хвилини фіксується кількість активних сесій.</li>
            <li>Для кожного часового інтервалу обчислюється <b>середнє по хвилинах</b>.</li>
            <li>Значення інтервалів формують профіль середньої аудиторії (AQH) за період.</li>
          </ol>
          <Thumbnail
            src="/assets/stats/AQH (uk)01.png"
            alt="AQH — графік"
          />
        <Thumbnail
            src="/assets/stats/AQH (uk)02.png"
            alt="AQH — теплокарта"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Reach (Period Reach)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Reach показує, <b>скільки унікальних слухачів</b> хоча б раз слухали станцію за обраний період.
            Всі повторні заходи одного унікального слухача — в один день чи протягом тижня або місяця — рахуються лише один раз.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Reach дозволяє:</p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>бачити, скільки унікальних слухачів хоча б раз увімкнули станцію за вибраний період (день, тиждень, місяць або довільний діапазон);</li>
            <li>показувати рекламодавцям, скільки різних людей фактично могли почути їхню рекламу в цей період;</li>
            <li>дивитися географію цих унікальних слухачів (топ країн + частка «без географії»).</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Як рахується:</p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            За обраний період ми збираємо всіх слухачів, які хоча б раз слухали радіо, і рахуємо кожного слухача один раз.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Якщо слухач слухав радіо 10 разів за тиждень — у Reach це 1 слухач за тиждень, а не 10.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Наприклад: людина слухала у понеділок, середу і пʼятницю — у тижневому Reach вона рахується як один слухач за тиждень.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Тому Reach показує не кількість включень, а саме кількість різних людей, які за цей час хоча б раз слухали ваше радіо.
          </p>
          <Thumbnail
            src="/assets/stats/Reach_uk.png"
            alt="Reach — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Утримання</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Чи повертаються слухачі?</b><br />
            Міряє, скільки нових слухачів повертаються наступного дня або тижня. Ключ до оцінки першого враження.
          </p>
          <Thumbnail
            src="/assets/stats/RetentionService(uk).png" 
            alt="Утримання — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Індекс лояльності</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Хто ваше ядро?</b><br />
            Виділяє постійних слухачів, які слухають регулярно. Показує силу бренду та довіру до контенту.
          </p>
          <Thumbnail
            src="/assets/stats/LoyaltyService(uk).png"
            alt="Індекс лояльності — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TOP</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Що найпопулярніше?</b><br />
            Формує рейтинги: топ міст, платформ, пристроїв, а також (якщо є дані) — музики та шоу. Готова статистика для презентацій.
            <br />
            Потребує імпорту сітки мовлення радіо
          </p>
          <Thumbnail
            src="/assets/stats/Top40Service(uk).png"
            alt="TOP — приклад інтерфейсу"
          />
        </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>LTR (Listen-Through Rate)</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Дослуховуваність аудіореклами.</b><br />
            Сервіс LTR показує, який відсоток слухачів фактично дослуховують рекламні блоки до кінця. Ця метрика перетворює результат
            «ролик вийшов в ефір» на чесне запитання: <b>«Скільки людей реально почули рекламу до фіналу?»</b>
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Що рахує LTR</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              <b>Impressions</b> — скільки унікальних слухачів були підключені на початку блоку;
            </li>
            <li>
              <b>Completions</b> — скільки залишилися до кінця блоку;
            </li>
            <li>
              <b>LTR, %</b> — частка тих, хто дослухав (Completions / Impressions × 100).
            </li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Дані показуються для кожного рекламного блоку за обраний день: час початку й завершення, склад (ролики), кількість слухачів та
            відсоток дослуховуваності.
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Як це працює</h4>
          <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Сервіс бере фактичний ефірний розклад й визначає рекламні блоки.</li>
            <li>
              Для кожного блоку фіксується, хто слухав на старті (impressions) і хто залишився до кінця (completions) за даними сесій.
            </li>
            <li>На цій основі система розраховує LTR у відсотках для кожного блоку окремо.</li>
          </ol>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Для чого використовувати</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Оцінка ефективності аудіореклами та пошук «провальних» роликів.</li>
            <li>Порівняння креативів і розміщень за силою утримання аудиторії.</li>
            <li>Оптимізація розкладу — видно, у які часові слоти реклама працює краще.</li>
            <li>Аргументи для продажів: реальний відсоток дослуховуваності замість абстрактних показів.</li>
          </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Сервіс LTR доступний у розділі «Статистика» як окремий інструмент аналізу рекламних блоків.
        </p>
        <Thumbnail src="/assets/stats/lpt_uk.png" alt="LTR — приклад інтерфейсу" />
      </section>

        <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Quartiles LTR (Listen-Through Rate by Quartiles)
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Дослуховуваність аудіореклами по квартилях.</b>
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Сервіс Quartiles LTR показує, скільки реальних слухачів дослухали рекламний ролик до 25%, 50%, 75% і 100% його тривалості.
            Для кожного виходу система фіксує Impressions (скільки унікальних слухачів було в ефірі на старті) та кількість людей, які дійшли до кожного квартиля.
          </p>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Якщо LTR дає одну фінальну точку «дослухав/не дослухав», то Quartiles LTR показує, де саме аудиторія починає «відвалюватися».
          </p>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Що рахує Quartiles LTR</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              <b>Impressions</b> — скільки унікальних слухачів підключені на старті конкретного ролика.
            </li>
            <li>
              <b>Q25/Q50/Q75/Q100</b> — скільки слухачів дослухали до 25%, 50%, 75% і 100% тривалості.
            </li>
            <li>
              Для кожного виходу формується добовий зріз: початок/кінець, назва ролика, кількість слухачів на кожному квартилі.
            </li>
          </ul>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Окремо сервіс рахує</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              <b>GEO по ролику</b> — скільки слухачів цього виходу було з кожної країни.
            </li>
            <li>
              <b>IP-рівень</b> — технічний список IP-адрес слухачів, які потрапили у вибірку для конкретного ролика й країни.
            </li>
          </ul>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Як це працює</h4>
          <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>Сервіс бере фактичний ефірний розклад і знаходить усі рекламні ролики за добу.</li>
            <li>Для кожного ролика знаходяться всі слухачі, які були в ефірі на момент старту (impressions).</li>
            <li>За даними сесій вимірюється, яку частину ролика кожен слухач реально прослухав (з допуском у ±5 секунд).</li>
            <li>Кожен слухач потрапляє в максимальний квартиль (0/25/50/75/100%), після чого система рахує кількість людей на кожному рівні.</li>
            <li>Паралельно формується GEO-зріз по роликах (країна → кількість слухачів) і IP-список.</li>
          </ol>
          <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Для чого використовувати</h4>
          <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
            <li>
              Реальна оцінка ефективності аудіореклами: видно, скільки слухачів дійшли до 25%, 50%, 75% і 100% тривалості.
            </li>
            <li>Порівняння креативів одного рекламодавця та різних розміщень за глибиною прослуховування.</li>
            <li>Оцінка позиції ролика в блоці — перший, середина, останній — де аудиторія тримається краще.</li>
            <li>Аналіз по GEO — як різні країни реагують на один і той самий ролик, чи добиває реклама до потрібних ринків.</li>
            <li>Глибока технічна перевірка: за потреби можна спуститися до IP-рівня.</li>
            <li>
              Модель «оплата за прослуханий ролик» — можна рахувати лише ті покази, де слухач дослухав 50–75% і знаходиться в потрібній країні.
            </li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Сервіс Quartiles LTR доступний у розділі «Статистика» як окремий інструмент аналізу рекламних роликів з деталізацією по квартилях, GEO та IP.
          </p>
          <Thumbnail src="/assets/stats/quartiles_ltr_uk01.png" alt="Quartiles LTR — таблиця квартилів" />
          <Thumbnail src="/assets/stats/quartiles_ltr_uk02.png" alt="Quartiles LTR — GEO по ролику" />
          <Thumbnail src="/assets/stats/quartiles_ltr_uk03.png" alt="Quartiles LTR — деталізація по IP" />
        </section>

        <section>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Статистика реклами</h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            <b>Яка ефективність реклами?</b><br />
            Рахує покази, охоплення, частоту та CPM. Дає зрозумілу та прозору статистику для рекламодавців.
            <br />
            Потребує імпорту сітки мовлення радіо
          </p>
          <Thumbnail
            src="/assets/stats/AdsService(uk).png"
            alt="Статистика реклами — приклад інтерфейсу"
          />
        </section>
      </div>

      {/* Лайтбокс для полноразмерного просмотра */}
      {lightbox.open && (
        <div
          onClick={() => setLightbox({ open: false, src: "", alt: "" })}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
            padding: 10,
          }}
        >
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            style={{
              maxWidth: "96vw",
              maxHeight: "92vh",
              objectFit: "contain",
              display: "block",
              background: "#fff",
              borderRadius: 8,
            }}
          />
        </div>
      )}
    </>
  );
}
